import React, { useState, useEffect } from "react";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { LoanRequestValidationSchema } from "../../components/Custom/ValidationSchema";
const validationSchema = LoanRequestValidationSchema();

export default function SendLoanRequest() {
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);
  const [lenders, setLenders] = useState([]);
  const [incorporationYear, setIncorporationYear] = useState("");

  useEffect(() => {
    fetchLendersList();
    fetchOrganizationDetails();
  }, []);

  const fetchLendersList = () => {
    api
      .get("/lending/get-lender-list")
      .then((response) => {
        setLenders(response.data);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
      });
  };

  // const fetchOrganizationDetails = () => {
  //   api
  //     .get("/fpo/fpo-details-get-set")
  //     .then((response) => {
  //       console.log(response.data);
  //       setIncorporationYear(response.data.year_of_incorporation);
  //       setFormData(() => ({
  //         ["operation_since"]: incorporationYear,
  //       }));
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching lenders:", error);
  //     });
  // };

  const fetchOrganizationDetails = () => {
    api
      .get("/fpo/fpo-details-get-set")
      .then((response) => {
        console.log(response.data);
        setIncorporationYear(response.data.year_of_incorporation);
        setFormData((prevData) => ({
          ...prevData,
          ["operation_since"]: response.data.year_of_incorporation,
        }));
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    validate(name, value);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const createLoanRequest = (e) => {
    console.log("form data is : ", formData);

    validate(formData);
    e.preventDefault();

    api
      .post("lending/add-loan-request/", formData)
      .then((response) => {
        console.log("Response from POST request:", response.data);
        alert("Loan request sent successfully");
        window.location.href = "/fpo/loans";
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };
  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <CustomTitle>{t("Send Loan Request")}</CustomTitle>

          <div>
            <FormControl fullWidth sx={{ marginTop: 2 }}>
              <InputLabel id="token-select-label">{t("Lender")} </InputLabel>
              <Select
                label={t("Lender")}
                name="lender"
                value={formData.lender || ""}
                onChange={handleChange}
              >
                {lenders.map((lender) => (
                  <MenuItem key={lender.id} value={lender.id}>
                    {lender.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.lender && (
                <Typography variant="caption" color="error">
                  {errors.lender}
                </Typography>
              )}
            </FormControl>

            <TextField
              margin="normal"
              fullWidth
              label={t("Amount")}
              type="number"
              name="amount"
              value={formData.amount || ""}
              onChange={handleChange}
              error={!!errors.amount} // Set error prop based on whether there's an error
              helperText={errors.amount}
              placeholder="Enter Amount"
              InputLabelProps={{ shrink: true }}
            />

            <FormControl fullWidth sx={{ marginTop: 2 }}>
              <InputLabel
                id="loanType-select-label"
                // shrink={true}
                // placeholder="Enter Loan Type"
              >
                {t("Loan Type")}
              </InputLabel>
              <Select
                // label={t("Loan Type")}
                name="loan_type"
                value={formData.loan_type || ""}
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="Working Capital">Working Capital</MenuItem>
                <MenuItem value="Invoice Finance">Invoice Finance</MenuItem>
                <MenuItem value="Warehouse Finance">Warehouse Finance</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
              {errors.loan_type && (
                <Typography variant="caption" color="error">
                  {errors.loan_type}
                </Typography>
              )}
            </FormControl>

            {/* <TextField
              margin="normal"
              fullWidth
              label={t("Pin / Zip Code")}
              type="number"
              name="pincode"
              value={formData.pincode || ""}
              onChange={handleChange}
              error={!!errors.pincode} // Set error prop based on whether there's an error
              helperText={errors.pincode}
              placeholder="Enter Pin / Zip Code"
              InputLabelProps={{ shrink: true }}
            /> */}

            {/* <AddressForm
              addressData={addressData}
              handleAddressChange={handleAddressChange}
              showAllFields={true}
              t={t} // Replace with your translation function
              handleFieldChange={(field, value) =>
                handleProfileDataChange({ [field]: value })
              }
              profileData={profileData}
              updateProfileData={handleProfileDataChange}
            /> */}

            <TextField
              margin="normal"
              fullWidth
              label={t("Operational Since")}
              type="number"
              name="operation_since"
              value={incorporationYear}
              onChange={handleChange}
              disabled
              // placeholder="Enter Address"
              // InputLabelProps={{ shrink: true }}
            />

            <TextField
              margin="normal"
              fullWidth
              label={t("Revenue")}
              type="number"
              name="revenue"
              value={formData.revenue || ""}
              onChange={handleChange}
              error={!!errors.revenue}
              helperText={errors.revenue}
              placeholder="Enter Revenue"
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <CustomButton onClick={createLoanRequest}>{t("Submit")}</CustomButton>
        </Grid>
      </Container>
    </>
  );
}
